/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 *
 * @export
 * @interface ZendeskSearchBody
 */
export interface ZendeskSearchBody {
    /**
     *
     * @type {string}
     * @memberof ZendeskSearchBody
     */
    freeText: string;
    /**
     *
     * @type {number}
     * @memberof ZendeskSearchBody
     */
    limit?: number;
    /**
     *
     * @type {number}
     * @memberof ZendeskSearchBody
     */
    offset?: number;
}

export function ZendeskSearchBodyFromJSON(json: any): ZendeskSearchBody {
    return ZendeskSearchBodyFromJSONTyped(json, false);
}

export function ZendeskSearchBodyFromJSONTyped(json: any, _: boolean): ZendeskSearchBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'freeText': json['free_text'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
    };
}

export function ZendeskSearchBodyToJSON(value?: ZendeskSearchBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'free_text': value.freeText,
        'limit': value.limit,
        'offset': value.offset,
    };
}
